// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Comment1: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 55"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M30.3.5C13.8.5.9 11 .9 24.4c0 8 5.7 13.8 10.5 17.2v12.1c0 .3.1.5.3.6.1.1.3.1.5.1h.3c.2-.1.5-.2.8-.4.4-.2.8-.4 1.1-.5 1.3-.7 5.9-3.3 10-7.7 2.2.4 4.6.8 6.9.8 16.7 0 28-8.9 28-22.2C59.2 10.8 46.7.5 30.3.5zM13.1 40.1c-3.7-2.5-10-7.9-10-15.7C3.1 12.3 15 2.8 30.2 2.8c15.1 0 26.5 9.3 26.5 21.6 0 11.9-10.3 19.9-25.6 19.9-2.5 0-5.3-.5-7.2-.9h-.6l-.3.4c-3.4 3.8-7.5 6.4-9.4 7.4V40.5l-.5-.4z"/></svg>;
};

export default React.memo(Comment1);
